export enum FornecedorTypes {
  'LOAD_REQUEST' = '@fornecedor/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@fornecedor/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@fornecedor/LOAD_FAILURE',

  'CLEAN_MOVIENTRADA' = '@fornecedor/CLEAN_MOVIENTRADA',
}

export interface IFornecedor {
  codParc: number;
  nome: string;
  cnpjCpf: string;
}

export interface FornecedorState {
  readonly data: IFornecedor[];
  readonly loading: boolean;
  readonly error: boolean;
}
